import React, { useCallback, useEffect, useRef, useState } from 'react'

export default function useDebouncedState<StateType = unknown>(
  delay: number,
  defaultState: StateType = void 0
): [StateType, React.Dispatch<React.SetStateAction<StateType>>] {
  const [state, setState] = useState<StateType>(defaultState)
  const timeoutId = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => () => clearTimeout(timeoutId.current), [])

  const setDebouncedState = useCallback(
    (state: React.SetStateAction<StateType>) => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current)
      }

      if (0 > delay) {
        timeoutId.current = void 0
        setState(state)
      } else {
        timeoutId.current = setTimeout(() => {
          setState(state)
        }, delay)
      }
    },
    [delay]
  )

  return [state, setDebouncedState]
}
